import { render, staticRenderFns } from "./TheModalAntecedente.vue?vue&type=template&id=6a183696&"
import script from "./TheModalAntecedente.vue?vue&type=script&lang=js&"
export * from "./TheModalAntecedente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports